import moment from "moment";

import { convertToLocalDateTime } from "components/helpers";
import { TableLink } from "components/BaseTableV3/TableLink";
import { SendEmailModal } from "routes/campaign/components/Modals";
import CampaignStatusModal from "routes/campaign/components/CampaignStatusModal";
import { CampaignTableActions } from "routes/entity/components/campaign_table/CampaignTableActions";

const enableEmails = ({ contact_id, has_contacts, sendEmail }) =>
  sendEmail ? sendEmail : contact_id ? false : has_contacts;

export const getCampaignTableColumns = ({
  canEmail,
  sendEmail,
  entityId,
  invalidateData,
  handleRemoveCampaignView,
}) => {
  return [
    {
      header: "ID",
      id: "ID",
      accessorKey: "campaign_id",
      size: 60,
      cell: ({ row }) => (
        <TableLink
          href={`/campaigns/${row.original?.campaign_id}/target/${row.original?.entity_id}`}
        >
          {row.original?.campaign_id}
        </TableLink>
      ),
    },
    {
      header: "Campaign Name",
      id: "Campaign Name",
      accessorKey: "campaign_name",
      cell: ({ row }) => (
        <TableLink
          href={`/campaigns/${row.original?.campaign_id}/target/${row.original?.entity_id}`}
        >
          {row.original?.campaign_name}
        </TableLink>
      ),
    },
    {
      header: "Assignee",
      id: "Assignee",
      accessorKey: "assignee_full_name",
    },
    {
      header: "Send Email",
      id: "Send Email",
      enableSorting: false,
      cell: ({ row }) =>
        canEmail ? (
          <SendEmailModal
            campaignId={row.original?.campaign_id}
            entityId={row.original?.entity_id}
            contactId={row.original?.contact_id}
            disabled={
              !enableEmails({
                contact_id: row.original?.contact_id,
                has_contacts: row.original?.has_contacts,
                sendEmail,
              })
            }
          />
        ) : null,
    },
    {
      header: "Campaign Status",
      id: "Campaign Status",
      accessorKey: "campaign_status",
      cell: ({ row }) => (
        <CampaignStatusModal
          campaignStatus={row.original?.campaign_status}
          campaignId={row.original?.campaign_id}
          entityId={row.original?.entity_id}
          contactId={row.original?.contact_id}
          updateData={invalidateData}
          entityName={row.original?.entity_name}
          effectiveDate={row.original?.effective_date}
        />
      ),
    },
    {
      header: "Effective Date",
      id: "Effective Date",
      accessorKey: "effective_date",
      cell: ({ row }) => {
        const value = row?.original?.effective_date;
        if (value !== undefined && value !== null) {
          return moment(value).format("YYYY-MM-DD");
        }
        return "N/A";
      },
    },
    {
      header: "Last Status Updated",
      id: "Last Status Updated",
      accessorKey: "status_last_updated_at",
      cell: ({ row }) => {
        const value = row.original?.status_last_updated_at;
        if (value !== undefined && value !== null) {
          return convertToLocalDateTime(value).format("YYYY-MM-DD");
        }
        return "N/A";
      },
    },
    {
      header: <div></div>,
      id: "Actions",
      accessorKey: "actions",
      size: 60,
      enableSorting: false,
      enableResizing: false,
      meta: {
        isDisplay: true,
      },
      cell: ({ row }) => (
        <CampaignTableActions
          entityId={entityId}
          original={row.original}
          invalidateData={invalidateData}
          handleRemoveCampaignView={handleRemoveCampaignView}
        />
      ),
    },
  ];
};
